import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, 
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER, } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from './reducers/index';
import { createTransform } from 'redux-persist';


const persistConfig = {
  key: 'jr-ciao-root',
  storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {
  const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.REACT_APP_ENV === "development", // DevTools only in development
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Disable serializableCheck for specific redux-persist internal actions.
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  })
  let persistor = persistStore(store)

  return { store, persistor }
}

